import $ from 'jquery';
import { getWidth } from '../utils/window';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');
	const $headerBg = $('.header_bg');
	const li = $headerNav.find('li.-parent');

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});

		$header.find('a[href^="#"]').on('click', function() {
			headerToggler.close();
		});

		// console.log(li);

		if(getWidth() > 1080 ) {
			li.each(function(e){
				const _this = $(this);
	
				console.log(_this);
	
				_this.mouseenter(function(er){
					$headerBg.fadeIn('fast', function(){
						$headerBg.addClass('-show');
					});
				});
	
				_this.mouseleave(function(er){
					$headerBg.fadeOut('fast', function(){
						$headerBg.removeClass('-show');
					});
				});
			});
		} else {
			li.each(function(e){
				const _this = $(this);
				const _thisA = $(this).find('> a');
				const _inner = _this.find('> ul');
				// console.log(_this);
	
				_thisA.click(function(e){
					e.preventDefault();
					if(_inner.hasClass('slided')) {
						_inner.slideUp('fast', function(){
							_inner.removeClass('slided');
						});
					} else {
						_inner.slideDown('fast', function(){
							_inner.addClass('slided');
						});
					}
				});
			});
		}
		
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js